import { useState } from "react";
import { Users } from "lucide-react";
import { Pill } from "../AdminBits";
import { AdminTable, FilterTabs, ListFrame, MoreFooter, SearchBox } from "../ListBits";
import useAdminList from "../../../hooks/useAdminList";
import { ROLE_LABELS } from "../../../lib/jamoraAdmin";
import { formatDateTime } from "../../../lib/tickets";

const STATE_TABS = [["", "Tous"], ["true", "Actifs"], ["false", "Désactivés"]];

// The accounts of one pharmacy: identifier, name, role, state, last sign-in. Never a password, a PIN or a token.
export default function UsersTab({ schema }) {
  const [active, setActive] = useState("");
  const [search, setSearch] = useState("");
  const list = useAdminList(`/pharmacies/${schema}/users`, { active, search });
  const columns = [
    { id: "name", label: "Nom", primary: true, cell: (u) => <span>{u.name || u.username}<span className="block text-xs text-slate-500">{u.username}</span></span> },
    { id: "role", label: "Rôle", cell: (u) => ROLE_LABELS[u.role] || u.role },
    { id: "state", label: "État", cell: (u) => <Pill tone={u.active ? "emerald" : "red"}>{u.active ? "Actif" : "Désactivé"}</Pill> },
    { id: "email", label: "E-mail", hide: "lg", cell: (u) => u.email || "—" },
    { id: "phone", label: "Téléphone", hide: "xl", cell: (u) => u.phone || "—" },
    { id: "login", label: "Dernière connexion", cell: (u) => (u.last_login ? formatDateTime(u.last_login) : "Jamais") },
  ];
  return (
    <div className="space-y-4" data-testid="pharmacy-users">
      <div className="flex items-center gap-2 flex-wrap">
        <FilterTabs label="État du compte" tabs={STATE_TABS} value={active} onChange={setActive} testid="users-state" />
        <SearchBox value={search} onChange={setSearch} placeholder="Identifiant ou nom…" testid="users-search" />
      </div>
      <ListFrame list={list} empty={{ icon: Users, title: "Aucun compte", hint: active || search ? "Essayez un autre filtre." : "Cette pharmacie n'a pas encore de compte.", testid: "users-empty" }}>
        <AdminTable columns={columns} rows={list.items} rowKey={(u) => u.id} testid="users-table" />
        <MoreFooter list={list} noun="compte(s)" testid="users" />
      </ListFrame>
    </div>
  );
}
